// Scroll Behaviour
import React, { useState, useEffect } from "react";
import { Menu, X, Search, LogIn } from "lucide-react";
import { useNavigate } from "react-router-dom";
import Logonobg from "../../Images/CS-without-bg.png";

function HeaderWithSidePanel() {
  const [isOpen, setIsOpen] = useState(false);
  // const [isIndustryOpen, setIsIndustryOpen] = useState(false);
  const [isContactOpen, setIsContactOpen] = useState(false);
  const navigate = useNavigate();
  const [holdTimer, setHoldTimer] = useState(null);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const isScrolled = window.scrollY > 20;
      setScrolled(isScrolled);
    };
    //verify#5272019

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll); // Cleanup
  }, []);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
    document.body.style.overflow = !isOpen ? "hidden" : "unset";
  };

  const handleHoldStart = () => {
    const timer = setTimeout(() => {
      navigate("/blogs", { state: { userType: "admin" } });
    }, 5000);
    setHoldTimer(timer);
  };

  const handleHoldEnd = () => {
    if (holdTimer) {
      clearTimeout(holdTimer);
      setHoldTimer(null);
    }
  };

  const handleLogin = () => {
    window.location.href = "https://app.attest360.com/bgv/login";
  };

  const handleClick = () => {
    const element = document.getElementById("industry-solutions");
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
    setIsOpen(!isOpen);
    document.body.style.overflow = !isOpen ? "hidden" : "unset";
  };
  const handleClickwhyus = () => {
    const element = document.getElementById("why-us");
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
    setIsOpen(!isOpen);
    document.body.style.overflow = !isOpen ? "hidden" : "unset";
  };

  return (
    <>
      {/* Header */}
      <div
        className={`fixed top-0 left-0 w-full z-50 flex items-center justify-between p-6 shadow-md transition-all duration-300 ${
          scrolled ? "bg-black/80 backdrop-blur-sm" : "bg-red-700"
        }`}
      >
        <div className="flex flex-col md:flex-row items-center justify-between w-full px-4">
          {/* Left Section: Menu, Logo, Login (mobile), H1 (desktop) */}
          <div className="flex items-center w-full md:w-auto">
            {/* Menu Button */}
            <button onClick={toggleMenu} className="text-white">
              <Menu size={40} />
            </button>
            {/* Logo */}
            <img
              src={Logonobg}
              alt="Criterion Screeners"
              className="h-12 lg:h-16 transition-all duration-300 cursor-pointer ml-5"
              onClick={() => navigate("/")}
            />
            {/* Login Button - Next to Logo on mobile, right-aligned on desktop */}
            <div className="md:absolute md:right-4 md:mt-0 mt-0 ml-4 md:ml-0">
              <button
                onClick={handleLogin}
                className="flex items-center gap-2 bg-white text-[#C4392A] hover:bg-[#C4392A] hover:text-white px-2 py-2 lg:px-4 lg:py-2 rounded-md font-medium transition-colors duration-300 shadow-md"
              >
                <LogIn size={18} />
                <span className="hidden md:block">Login</span>
              </button>
            </div>
            {/* H1 - Hidden on mobile, shown on desktop */}
            <h1 className="hidden md:block text-white text-3xl font-semibold ml-52">
              AI Based Verification Platform
            </h1>
          </div>

          {/* H1 for Mobile - Below everything */}
          <h1 className="md:hidden text-white text-lg font-semibold mt-4 text-center">
            AI Based Verification Platform
          </h1>
        </div>
      </div>
      {/* Side Panel */}
      <div
        className={`fixed inset-0 z-50 flex transform transition-transform duration-500 ease-out ${
          isOpen ? "translate-x-0" : "-translate-x-full"
        }`}
      >
        <div
          className={`fixed inset-0 bg-black transition-opacity duration-500 ${
            isOpen ? "bg-opacity-50" : "bg-opacity-0"
          }`}
          onClick={toggleMenu}
        />

        <div className="relative flex w-full lg:w-2/3 bg-red-700 text-white transform transition-transform duration-500 ease-out">
          <div className="w-full px-6 lg:px-8 py-4 lg:py-6 flex flex-col">
            <div className="grid grid-cols-3 items-center">
              <X
                size={30}
                className="cursor-pointer hover:opacity-80 transition-all duration-300"
                onClick={toggleMenu}
              />
              <div className="flex justify-center">
                <img
                  src={Logonobg}
                  alt="Criterion Screeners"
                  className="h-16 lg:h-20 transition-all duration-300"
                  onMouseDown={handleHoldStart}
                  onMouseUp={handleHoldEnd}
                  onMouseLeave={handleHoldEnd}
                  onTouchStart={handleHoldStart}
                  onTouchEnd={handleHoldEnd}
                />
              </div>
              {/* <Search
                size={30}
                className="cursor-pointer justify-self-end hover:opacity-80 transition-all duration-300"
              /> */}
            </div>

            <nav className="flex-1 flex flex-col justify-center space-y-6 lg:space-y-8 mt-8 lg:mt-12 text-center">
              <a
                href="/"
                className="block text-2xl lg:text-3xl font-semibold hover:text-gray-200 hover:translate-x-2 transform transition-all duration-300"
              >
                Home
              </a>

              {/* Why us */}
              <div>
                <button
                  onClick={handleClickwhyus}
                  className="block text-2xl lg:text-3xl font-semibold hover:text-gray-200 hover:translate-x-2 transform transition-all duration-300 w-full text-center"
                >
                  Why Us
                </button>
              </div>

              {/* Industry Solutions Dropdown */}
              <div>
                <button
                  onClick={handleClick}
                  className="block text-2xl lg:text-3xl font-semibold hover:text-gray-200 hover:translate-x-2 transform transition-all duration-300 w-full text-center"
                >
                  Industry Solutions
                </button>
              </div>

              {/* <a
                href="/"
                className="block text-2xl lg:text-3xl font-semibold hover:text-gray-200 hover:translate-x-2 transform transition-all duration-300"
              >
                Why Us
              </a> */}

              {/* Contact Us Dropdown */}
              <div>
                <button
                  onClick={() => setIsContactOpen(!isContactOpen)}
                  className="block text-2xl lg:text-3xl font-semibold hover:text-gray-200 hover:translate-x-2 transform transition-all duration-300 w-full text-center"
                >
                  Contact Us
                </button>
                {isContactOpen && (
                  <div className="flex flex-col sm:flex-row gap-4 sm:gap-7 justify-center mt-5 text-lg">
                    <a
                      href="https://www.facebook.com/profile.php?id=61576150105402"
                      className="block hover:text-gray-200 transition-all duration-300"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Facebook
                    </a>
                    <a
                      href="https://www.instagram.com/verifydigital?utm_source=qr&igsh=aWRiaG10dDUxZDMz"
                      className="block hover:text-gray-200 transition-all duration-300"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Instagram
                    </a>
                    <a
                      href="https://x.com/home"
                      className="block hover:text-gray-200 transition-all duration-300"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Twitter
                    </a>
                    <a
                      href="https://www.linkedin.com/company/criterion-screeners/posts/?feedView=all"
                      className="block hover:text-gray-200 transition-all duration-300"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Linkedin
                    </a>
                    <a
                      href="mailto:Intouch@criterionscreeners.com"
                      className="cursor-pointer"
                    >
                      Email: Intouch@criterionscreeners.com
                    </a>
                  </div>
                )}
              </div>
            </nav>

            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-40 mt-auto text-sm p-6 lg:p-12">
              <div className="text-center lg:text-left">
                <h2 className="text-xl lg:text-2xl font-semibold mb-2">
                  Corporate Office
                </h2>
                <p className="text-gray-100 text-base lg:text-lg">
                  Innovator Building, ITPL,
                  <br /> Whitefield Road, Bengaluru,
                  <br /> Karnataka - 560066
                  <p className="mb-2 mt-2">☏ +91 40452 09581</p>
                </p>
              </div>
              <div className="text-center lg:text-left">
                <h3 className="text-xl lg:text-2xl font-semibold mb-2">
                  Branch Office
                </h3>
                <p className="text-gray-100 text-base lg:text-lg">
                  Ardente Office One,
                  <br /> Hoodi, Bengaluru,
                  <br /> Karnataka - 560048
                  <p className="mb-2 mt-2">☏ +91 80711 88588 </p>
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="lg:w-1/3 bg-white/30 backdrop-blur-lg border-0 border-white/10 rounded-lg shadow-lg bg-opacity-20" />
      </div>
    </>
  );
}

export default HeaderWithSidePanel;
